export default {
  'Custom': '自定義',
  'Original': '原始',
  'Resolution': '分辨率',
  'Frame rate': '幀率',
  'The higher the frame rate, the smoother the animation': '幀率越高，動畫越流暢。',
  'Start': '開始',
  'End': '結束',
  'Create GIF': '製作GIF',
  'Download GIF': '下載GIF',
  'Create A New One': '製作新GIF',
  'Remake GIF': '重新製作GIF',
  'HitPaw Video to GIF Online': '在线视频转GIF',
  'Upload and convert video to GIF without any difficulty': '在线视频转GIF描述',
}